import React from 'react';

import { v4 as uuid } from 'uuid';

import AddControl from 'components/add_control';
import Contact from './contact';

import type { Contact as ContactType, ContactsTask } from 'bundles/apex/tasks/types';

interface Props {
  contacts: ContactType[];
  contactsTasks: ContactsTask[];
  onChange: (conactsTask: ContactsTask[]) => void;
}

export default function Contacts({ contacts, contactsTasks, onChange }: Props) {
  contactsTasks = contactsTasks.filter(contactsTask => !contactsTask._destroy);
  contacts = contacts.filter((contact) => {
    return !contactsTasks.some(contactsTask => contactsTask.contact.id === contact.id);
  }) || [];

  function addContactsTask() {
    onChange([
      ...contactsTasks,
      { contact: contacts[0], localId: uuid() },
    ]);
  }

  function replaceContactsTask(replacement: ContactsTask) {
    onChange(contactsTasks.map((contactsTask) => {
      if (contactsTask.localId === replacement.localId) {
        contactsTask = replacement;
      }

      return contactsTask;
    }));
  }

  function deleteContactsTask(contactsTask: ContactsTask) {
    onChange(contactsTasks.map((existingContactsTask) => {
      if (contactsTask.localId === existingContactsTask.localId) {
        existingContactsTask = { ...existingContactsTask, _destroy: true };
      }

      return existingContactsTask;
    }));
  }

  return (
    <>
      {(contactsTasks.length > 0 || contacts.length > 0) &&
        <h6>Contacts</h6>
      }

      {contactsTasks.map(contactsTask => (
        <Contact
          contacts={contacts}
          contactsTask={contactsTask}
          key={contactsTask.localId}
          onChange={replaceContactsTask}
          onDelete={deleteContactsTask}
        />
      ))}

      {contacts.length > 0 &&
        <div>
          <AddControl onClick={addContactsTask}>Add Contact</AddControl>
        </div>
      }
    </>
  );
}
